import { render, staticRenderFns } from "./PlpProducts21.vue?vue&type=template&id=67b7fe76&scoped=true&"
import script from "./PlpProducts21.vue?vue&type=script&lang=js&"
export * from "./PlpProducts21.vue?vue&type=script&lang=js&"
import style0 from "./PlpProducts21.vue?vue&type=style&index=0&id=67b7fe76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7fe76",
  null
  
)

export default component.exports